import { render, staticRenderFns } from "./InstanceTeachingNotes.vue?vue&type=template&id=0c08ccd9&scoped=true&"
import script from "./InstanceTeachingNotes.vue?vue&type=script&lang=js&"
export * from "./InstanceTeachingNotes.vue?vue&type=script&lang=js&"
import style0 from "./InstanceTeachingNotes.vue?vue&type=style&index=0&id=0c08ccd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c08ccd9",
  null
  
)

export default component.exports